export const measurementContent = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
    <style>
        .type-of-fold .heading {
            margin-bottom: 30px;
        }

        .type-of-fold .heading h4 {
            font-size: 20px;
            padding: 0 0 16px;
        }

        .type-of-fold .row {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px;
        }

        .type-of-fold-item h5 {
            margin: 0 0 24px;
            font-size: 18px;
        }

        .type-of-fold-item img {
            width: 100%;
            vertical-align: middle;
            height: auto;
            margin: 0 0 30px;
        }

        .type-of-fold-item p {
            margin: 0 0 16px;
        }

        .type-of-fold-item p:last-child {
            margin: 0;
        }

        .type-of-fold-item a {
            text-decoration: underline;
            color: inherit;
        }

        .type-of-fold .heading li {
            position: relative;
            list-style: none;
            padding: 0 0 0 24px;
            margin: 0;
        }

        .type-of-fold .heading ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        .type-of-fold .heading li:before {
            content: "";
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M6 11L9.5 14.5L17.5 6.5" stroke="%234BAD3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            position: absolute;
            top: 1px;
            width: 18px;
            height: 18px;
            background-size: 18px;
            left: 0;
        }

        .type-of-fold-item ul {
            margin: 0;
            padding: 0;
            list-style-position: inside;
        }

        .type-of-fold-item ul li {
            margin: 0 0 2px;
        }

        .type-of-fold-item ul li:last-child {
            margin: 0 0 2px;
        }

        @media (max-width: 767px) {
            .type-of-fold .row {
                grid-template-columns: 1fr;
            }
        }
    </style>
</head>

<body>
    <div class="type-of-fold">
        <div class="row">
            <div class="type-of-fold-item">
                <h5>width</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/7_2_1_Inbetween-gordijnen-breedte-1_1759322871009.jpg?v=1759753619" alt="Width measurement guide">
                <p>Enter your desired width here. Use the width measurement of an existing curtain rail or determine
                    your own desired width.</p>
                <p>Need help measuring? Your personal advisor is ready to assist you! Schedule a <a href="#">free
                        consultation</a> and have your window measured without obligation.</p>
            </div>
            <div class="type-of-fold-item">
                <h5>height</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/7_2_1_Inbetween-gordijnen-hoogte-1_1759322871017.jpg?v=1759753619" alt="Height measurement guide">
                <p>Enter the desired height here.</p>
                <ul>
                    <li>1. Measure from the ceiling to the floor or windowsill.</li>
                    <li>2. Do this in three different places, fill in the smallest measurement.</li>
                    <li>3. Please maintain the exact measurement and we will ensure the curtain hangs clear of the
                        floor.</li>
                </ul>
                <p>*If you already have a curtain rail, measure from the top of the rail. Then follow steps 2 and 3.</p>
                <p>Need help measuring? Request a free consultation and have your window measured by a consultant
                    without obligation. Is your ceiling too high? We're here for you too. Your personal consultant will
                    measure your entire window and ensure you get a perfectly fitting curtain.</p>
            </div>
        </div>
    </div>
</body>

</html>`;
